
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";

export const PageContainer = styled(Paper)(({
  padding: '18px 24px',
  boxShadow: 'none',
}))

